const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const fetchSalesPopup = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/admin/sales-popup/`);
    if (!response.ok) {
      if (response.status === 404) {
        // No hay configuración, retornar null
        return null;
      }
      throw new Error('Failed to fetch sales popup configuration');
    }
    return await response.json();
  } catch (error) {
    // Si es un error de red, verificar si es 404
    if (error.message && error.message.includes('404')) {
      return null;
    }
    throw error;
  }
};

export const updateSalesPopup = async (popupId, data) => {
  try {
    const response = await fetch(`${API_BASE_URL}/admin/sales-popup/${popupId}/`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to update sales popup');
    }
    return await response.json();
  } catch (error) {
    throw error;
  }
};

export const createSalesPopup = async (data) => {
  try {
    const response = await fetch(`${API_BASE_URL}/admin/sales-popup/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to create sales popup');
    }
    return await response.json();
  } catch (error) {
    throw error;
  }
};

export const fetchSalesPopupLeads = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/admin/sales-popup/leads/`);
    if (!response.ok) {
      throw new Error('Failed to fetch sales popup leads');
    }
    return await response.json();
  } catch (error) {
    throw error;
  }
};

